<template>
  <v-app>
    <appbarView />

    <v-container class="mt-10">
      <!-- Encabezado -->
      <v-card class="mb-6 pa-6 text-white" color="#0D47A1" elevation="3">
        <div class="text-center">
          <h1 class="text-h5 font-weight-bold mb-2">Panel de Inventario</h1>
          <p class="text-subtitle-1">Consulta en tiempo real el estado del stock de productos.</p>
        </div>
                  <ImportadorExistenciaView />

      </v-card>

      <!-- Barra de búsqueda -->
      <v-text-field
        v-model="search"
        label="Buscar por nombre o SKU"
        prepend-inner-icon="mdi-magnify"
        class="mb-4"
        clearable
        color="primary"
      />

      <!-- Tabla de stock -->
      <v-data-table
        v-if="stocks.length"
     
        :items="stocks"
        :search="search"
        :loading="loading"
        class="elevation-1"
        loading-text="Cargando stock..."
        items-per-page="10"
        density="comfortable"
        hover
      />

      <!-- Loader si no hay datos aún -->
      <div v-else class="text-center">
        <v-progress-circular indeterminate color="primary" class="my-6" />
        <p>Cargando stock...</p>
      </div>
    </v-container>

    <BottomNavigation />

  </v-app>
</template>

<script>
import axios from 'axios';
import appbarView from '../appbar/appbarView.vue';
import BottomNavigation from '../submenu/BottomNavigation.vue';
import ImportadorExistenciaView from './ImportadorExistenciaView.vue';

export default {
  name: 'VistaStock',
  components: {
    appbarView,
    BottomNavigation,
    ImportadorExistenciaView
  },
  data() {
    return {
      search: '',
      loading: true,
      stocks: [],
      headers: [
        { text: 'SKU', value: 'sku', align: 'start' },
        {  value: 'Nombre' },
        { text: 'Disponible Frog', value: 'yfr_disponible' },
        { text: 'Disponible ', value: 'invpro_existencia' },       
         { text: 'Almacen ', value: 'lugar' }

      ]
    };
  },
  async mounted() {
    try {
      const response = await axios.get('https://mvexpress.mx/api/get-stock');
      this.stocks = response.data.map((item) => ({
        sku: item.producto?.sku || '',
       nombre: item.producto?.nombre || '',
   
          invpro_existencia: item.invpro_existencia,
        yfr_disponible: item.yfr_disponible,
        lugar: item.lugar || ''
      }));
    } catch (error) {
      console.error('Error al obtener stock:', error);
    } finally {
      this.loading = false;
    }
  }
};
</script>
